import "./App.css";
import LitudianWrapped from "./components/wrapped";
import Intro from "./components/intro";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Intro name="" />} />
        <Route path="/:id" element={<LitudianWrapped />} />
      </Routes>
    </Router>
  );
}

export default App;
